import type { FC, ReactNode } from 'react';
import { Header } from './Header';
import { FooterVersion } from './FooterVersion';
import { VERSION } from '../../version';

interface LayoutProps {
  children: ReactNode;
  title?: string;
  subtitle?: string;
}

export const Layout: FC<LayoutProps> = ({ 
  children, 
  title = 'Beta',
  subtitle = ''
}) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100 p-4 md:p-8">
      <Header title={title} subtitle={subtitle} />
      
      <main className="max-w-4xl mx-auto bg-white rounded-xl shadow-md overflow-hidden">
        <div className="p-6 md:p-8">
          {children}
        </div>
      </main>
      
      <FooterVersion version={VERSION} />
    </div>
  );
};
